var map = {
	"./10C.png": 18,
	"./10D.png": 19,
	"./10H.png": 20,
	"./10S.png": 21,
	"./2C.png": 22,
	"./2D.png": 23,
	"./2H.png": 24,
	"./2S.png": 25,
	"./3C.png": 26,
	"./3D.png": 27,
	"./3H.png": 28,
	"./3S.png": 29,
	"./4C.png": 30,
	"./4D.png": 31,
	"./4H.png": 32,
	"./4S.png": 33,
	"./5C.png": 34,
	"./5D.png": 35,
	"./5H.png": 36,
	"./5S.png": 37,
	"./6C.png": 38,
	"./6D.png": 39,
	"./6H.png": 40,
	"./6S.png": 41,
	"./7C.png": 42,
	"./7D.png": 43,
	"./7H.png": 44,
	"./7S.png": 45,
	"./8C.png": 46,
	"./8D.png": 47,
	"./8H.png": 48,
	"./8S.png": 49,
	"./9C.png": 50,
	"./9D.png": 51,
	"./9H.png": 52,
	"./9S.png": 53,
	"./AC.png": 54,
	"./AD.png": 55,
	"./AH.png": 56,
	"./AS.png": 57,
	"./JC.png": 58,
	"./JD.png": 59,
	"./JH.png": 60,
	"./JS.png": 61,
	"./KC.png": 62,
	"./KD.png": 63,
	"./KH.png": 64,
	"./KS.png": 65,
	"./QC.png": 66,
	"./QD.png": 67,
	"./QH.png": 68,
	"./QS.png": 69,
	"./green_back.png": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;